import { createReleaseStore, parseReleaseInfo, type ReleaseInfo } from "./releaseLogic";

// 公開版の確認（docs/daytime_deployment_technical_design.md 6.1）。
// 公開版情報は Vercel の旧 deployment に固定されない独立 URL（Front Door の専用 path）から取る。

export const FRONTEND_NAME = "tenant";

// 配布 CI が build 時に焼き込む（.github/workflows/release-publish.yml）。従来の deploy では未設定で、
// その画面は自動更新も案内もしない
export const CLIENT_BUILD_ID = process.env.NEXT_PUBLIC_RELEASE_BUILD_ID || "unknown";

const RELEASE_INFO_URL = `${process.env.NEXT_PUBLIC_BACKEND_API_BASE_URL}/.well-known/nitoel-release.json`;

export const releaseStore = createReleaseStore();

// 認証 token / tenant 情報は送らない。取得失敗は null（画面操作を妨げず、更新を推測しない）
export const fetchPublishedRelease = async (fetchImpl: typeof fetch = fetch): Promise<ReleaseInfo | null> => {
  try {
    const res = await fetchImpl(RELEASE_INFO_URL, { cache: "no-store", credentials: "omit" });
    if (!res.ok) return null;
    return parseReleaseInfo(await res.json(), FRONTEND_NAME);
  } catch {
    return null;
  }
};

// proxy の応答に付ける build ID（設計 6.3）。API の build ID は API 応答から明示的に写す
// （proxy は応答ヘッダーをそのまま返さないため）。認可判定には使わない。
export const releaseResponseHeaders = (backendHeaders: Headers): Record<string, string> => {
  const headers: Record<string, string> = { "x-nitoel-proxy-build": process.env.NEXT_PUBLIC_RELEASE_BUILD_ID || "unknown" };
  const serverBuild = backendHeaders.get("x-nitoel-server-build");
  if (serverBuild) headers["x-nitoel-server-build"] = serverBuild;
  return headers;
};
